import styled from 'styled-components';
import { List } from '@material-ui/core';

export const StyledList = styled(List)`
  padding-top: 0;
`;
